import PropTypes from 'prop-types';

const Address = PropTypes.shape(
  {
    address: PropTypes.string.isRequired,
    lat: PropTypes.number,
    lng: PropTypes.number,
    category: PropTypes.string.isRequired,
  },
);
const Stop = PropTypes.shape(
  {
    stop_id: PropTypes.string.isRequired,
    stop_code: PropTypes.string.isRequired,
    stop_name: PropTypes.string.isRequired,
    stop_lat: PropTypes.number.isRequired,
    stop_lon: PropTypes.number.isRequired,
    location_type: PropTypes.number.isRequired,
  },
);
const Stops = PropTypes.arrayOf(Stop);

export default {
  Address,
  Stop,
  Stops,
};
